import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import miloUrl from '../../common/url';
import loginStatus from '../../common/loginStatus';
import Request from '../../common/network';
import miloObject from '../../common/object';
import miloCookie from '../../common/cookie';
import platform from '../../common/platform';
import { extend, isFunction, isArray } from '../../common/base';
import isSupportDomain from '../../common/supportDomain';
import postMessageProxy from '../../common/postMessageUtil';
import ATM from '../../util/atm';
import { getJsBridge } from '../../biz/jsBridge';
import { pcParams, loginByQQ_PC, loginByWX_PC, loginByQQConnect_PC, loginByWegame_PC, refreshWegame_PC, loginByQQAndWX_PC, loginByQQConnectAndWX_PC } from './loginFunc/pcLogin';
import { mobileParams, loginByQQ_Mobile, loginByWX_Mobile, loginByQQConnect_Mobile, loginByQQAndWX_Mobile, loginByQCAndWX_Mobile, loginByWegame_Mobile, loginByKs_Mobile, refreshWegame_Mobile, loginByWxDelegate as _loginByWxDelegate } from './loginFunc/mobileLogin';
import { frameManager, getLoginInterFace, loginCookie, proxyManager, isLegalAcctype, loginSvrCache, userInfoManager, getGameId } from './common';
var appJsBridge = getJsBridge(); // 页面document.domain是否可写;

var pageSupportDomain = true;

if (/(\.qq\.com)$/.test(document.location.host)) {
  // document.domain = 'qq.com';
  pageSupportDomain = isSupportDomain();
}

var commonParams = {
  loginMethods: [],
  // 当前页面采用的登录方式
  isPrivateLogin: false,
  // 是否私有登录态，如果为true，则不共享game.qq.com中的代理登录态，为false，则从game.qq.com中读取和写入登录态，默认为false
  iUseQQConnect: typeof window.iUseQQConnect !== 'undefined' ? window.iUseQQConnect : 0
};

var LoginManager = /*#__PURE__*/function () {
  function LoginManager(option) {
    _classCallCheck(this, LoginManager);

    var _ref = option || {},
        cPar = _ref.commonParams,
        mPar = _ref.mobileParams,
        pPar = _ref.pcParams; // 刷新下commParams.iUseQQConnect


    commonParams.iUseQQConnect = typeof window.iUseQQConnect !== 'undefined' ? window.iUseQQConnect : 0;
    this.option = {
      commonParams: extend(commonParams, cPar),
      mobileParams: extend(mobileParams, mPar),
      pcParams: extend(pcParams, pPar)
    };
    this.requestPool = []; // checkRealLogin请求池

    if (typeof this.option.commonParams.iUseQQConnect !== 'undefined') {
      window.iUseQQConnect = this.option.commonParams.iUseQQConnect;
    }

    if (!LoginManager.instance) {
      LoginManager.instance = this;
    } // 20220304 修复先实例化父类过，再实例化子类，导致子类this变更
    // return LoginManager.instance;

  }

  _createClass(LoginManager, [{
    key: "setOption",
    value: function setOption(option) {
      this.option = extend(this.option, option);

      if (typeof this.option.commonParams.iUseQQConnect !== 'undefined') {
        window.iUseQQConnect = this.option.commonParams.iUseQQConnect;
      }
    }
  }, {
    key: "checkAppUseQCLogin",
    value: function checkAppUseQCLogin() {
      return /GH_QQConnect/.test(window.navigator.userAgent);
    } // 综合判断iUseQQConnect，是否使用qc登录态

  }, {
    key: "isUseQC",
    value: function isUseQC(opt) {
      var option = _objectSpread(_objectSpread({}, this.option.commonParams), opt);

      var _ref2 = option || {},
          iUseQQConnect = _ref2.iUseQQConnect;

      if (this.checkAppUseQCLogin()) {
        window.iUseQQConnect = 1;
      }

      if (1 == window.iUseQQConnect) {
        iUseQQConnect = 1;
      }

      return iUseQQConnect;
    }
  }, {
    key: "isCTLogin",
    value: function isCTLogin() {
      if (miloCookie.get('acctype') === 'ct') {
        return true;
      }

      return false;
    }
    /*
    判断是否MSDK登录态
      */

  }, {
    key: "isMSDKLogin",
    value: function isMSDKLogin() {
      if (miloUrl.request('msdkEncodeParam')) {
        return true;
      }

      if (miloUrl.request('itopencodeparam')) {
        return true;
      }

      return false;
    }
    /*
     判断是否小程序透传登录态
    */

  }, {
    key: "isMpToH5Login",
    value: function isMpToH5Login() {
      if (miloUrl.request('miloMpLoginParams')) {
        return true;
      }

      if (miloUrl.request('miloMpSDKParams')) {
        return true;
      }

      return false;
    }
    /*
     判断是否直播中台登录态
    */

  }, {
    key: "isLiveLinkLogin",
    value: function isLiveLinkLogin() {
      return miloUrl.request('livePlatId') && miloUrl.request('sig') && miloUrl.request('code');
    }
    /*
    获取直播中台登录态参数
     	*/

  }, {
    key: "getLiveLinkParams",
    value: function getLiveLinkParams() {
      var arrKey = ['actId', 'appId', 'gameId', 'livePlatId', 'code', 'timestamp', 'v', 'sig'];
      var oParams = {}; // 从url上获取参数

      if (this.isLiveLinkLogin()) {
        for (var i = 0; i < arrKey.length; i++) {
          oParams[arrKey[i]] = miloUrl.request(arrKey[i]);
        }
      }

      return oParams;
    }
    /*
    获取msdk参数
     	*/

  }, {
    key: "getMSDKParams",
    value: function getMSDKParams() {
      var arrKey1 = ['appid', 'version', 'timestamp', 'sig', 'encode', 'algorithm', 'openid', 'source', 'msdkEncodeParam'];
      var arrKey2 = ['gameid', 'os', 'channelid', 'seq', 'ts', 'version', 'source', 'sig', 'itopencodeparam'];
      var oParams = {};

      if (this.isMSDKLogin()) {
        // 老版
        if (miloUrl.request('msdkEncodeParam')) {
          for (var i = 0; i < arrKey1.length; i++) {
            oParams[arrKey1[i]] = miloUrl.request(arrKey1[i]);
          }
        } // 新版


        if (miloUrl.request('itopencodeparam')) {
          for (var j = 0; j < arrKey2.length; j++) {
            oParams[arrKey2[j]] = miloUrl.request(arrKey2[j]);
          }
        }
      }

      return oParams;
    }
    /*
    获取小程序透传登录态参数
     	*/

  }, {
    key: "getMpParams",
    value: function getMpParams() {
      var oMpParams = ''; // 新版

      var miloMpLoginParams = miloUrl.request('miloMpLoginParams') || ''; // 老版

      var miloMpSDKParams = miloUrl.request('miloMpSDKParams') || '';

      if (!this.isMpToH5Login()) {
        return oMpParams;
      }

      try {
        if (miloMpLoginParams) {
          // decode两次应对IOS-QQ小程序的bug
          var decodedParams = decodeURIComponent(decodeURIComponent(miloMpLoginParams));
          var decodedParamsArray = decodedParams.split('|');

          if (decodedParamsArray.length >= 5 && decodedParamsArray.length <= 8) {
            if (decodedParamsArray.length === 5) {
              decodedParamsArray = decodedParamsArray.concat(['', '', '']);
            } else if (decodedParamsArray.length === 6) {
              decodedParamsArray = decodedParamsArray.concat(['', '']);
            } else if (decodedParamsArray.length === 7) {
              decodedParamsArray = decodedParamsArray.concat(['']);
            }

            var arrKeyList = ['acctype', 'openid', 'appid', 'ieg_ams_token_time', 'ieg_ams_session_token', 'ieg_ams_token', 'nick_name', 'avatar'];
            oMpParams = {};

            for (var i = 0; i < decodedParamsArray.length; i++) {
              oMpParams[arrKeyList[i]] = decodedParamsArray[i];
            }
          }
        } else if (miloMpSDKParams) {
          var _decodedParams = decodeURIComponent(decodeURIComponent(miloMpSDKParams));

          oMpParams = JSON.parse(_decodedParams);
        }
      } catch (e) {
        return oMpParams;
      }

      return oMpParams;
    } // 获取当前的前端登录态相关参数，包括从url传参

  }, {
    key: "getLoginStatusParams",
    value: function getLoginStatusParams() {
      // 接受url传入登录态
      if (miloUrl.request('milo_login_status')) {
        var oLoginStatusFromUrl = {};

        try {
          var loginStatusFromUrl = decodeURIComponent(miloUrl.request('milo_login_status'));
          var decodedParamsArray = loginStatusFromUrl.split('|');

          if (decodedParamsArray.length === 4) {
            // acctype|appid|openid|access_token
            var arrKeyList = ['acctype', 'appid', 'openid', 'access_token'];

            for (var i = 0; i < decodedParamsArray.length; i++) {
              oLoginStatusFromUrl[arrKeyList[i]] = decodedParamsArray[i];
            }
          } // 不接受传入uin，skey。使用qc登录态代替


          if (!oLoginStatusFromUrl.acctype) {
            return;
          }

          var acctype = oLoginStatusFromUrl.acctype,
              access_token = oLoginStatusFromUrl.access_token,
              openid = oLoginStatusFromUrl.openid,
              appid = oLoginStatusFromUrl.appid; // 必须acctype，access_token，openid,appid都指定，才算一个完整的登录态

          if (acctype && access_token && openid && appid) {
            loginCookie.setLocal({
              acctype: acctype,
              access_token: access_token,
              openid: openid,
              appid: appid
            });
          }
        } catch (e) {
          console.log('[Milo Core] milo_login_status - 传入登录态格式有误，请检查]', e);
        }
      } // 获取当前登录态


      return loginCookie.getAll();
    }
    /**
     * @method checkIsLoginWithoutRequest
     * @desc 不通过请求后端就可以直接判定是登录的情况，包括msdk，livelink，参数缺失，制定qc但无qc的cookie等
     * @param opt {object} 可选，作为和commParams同级的对象进行merge处理
    */

  }, {
    key: "checkIsLoginWithoutRequest",
    value: function checkIsLoginWithoutRequest(opt) {
      var iUseQQConnect = this.isUseQC(opt);
      var self = this;

      if (self.isMSDKLogin()) {
        // msdk登陆, url传参判断，优先级最高
        return {
          isLogin: true,
          userInfo: {}
        };
      }

      if (self.isLiveLinkLogin()) {
        // msdk登陆, url传参判断，优先级最高
        return {
          isLogin: true,
          userInfo: {}
        };
      }

      if (self.isCTLogin()) {
        // 鉴权接口不支持ct，直接逻辑接口鉴权 weiztang
        return {
          isLogin: true,
          userInfo: {}
        };
      }

      if (self.isMpToH5Login()) {
        // 小程序透传H5登录态, url传参判断，优先级高
        var oMpParams = self.getMpParams(); // console.log('oMpParams',oMpParams)

        if (oMpParams) {
          loginCookie.setLocal({
            openid: oMpParams.openid,
            acctype: oMpParams.acctype,
            appid: oMpParams.appid,
            ieg_ams_token_time: oMpParams.ieg_ams_token_time,
            ieg_ams_session_token: oMpParams.ieg_ams_session_token,
            ieg_ams_token: oMpParams.ieg_ams_token
          }, 7200);
          return {
            isLogin: true,
            userInfo: {}
          };
        }

        return {
          isLogin: false,
          errCode: 'errorMpParams',
          errMsg: '当前登录态失效,请重新登录',
          errInfo: {
            errMsg: '当前登录态失效,请重新登录'
          }
        };
      }

      if (iUseQQConnect !== 1 && miloCookie.get('acctype') === 'qc') {
        loginCookie.clearLocal(); // cookie中acctype为qc但是iUseQQConnect不为1则清除所有openid登录态，防止和pt冲突
      }

      if (iUseQQConnect === 1 && !miloCookie.get('acctype')) {
        // 页面指定QC登陆（非PT），没有acctype，直接返回登陆失效
        miloCookie.clear('IED_LOG_INFO_NEW', location.host, '/');
        return {
          isLogin: false,
          errCode: 'no_acctype',
          errMsg: '当前登录态失效,请重新登录',
          errInfo: {
            errMsg: '当前登录态失效,请重新登录'
          }
        };
      } // 无法判断需要其它逻辑


      return null;
    } // 强校验登录态

  }, {
    key: "checkRealLogin",
    value: function checkRealLogin() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      return new Promise(function (resolve, reject) {
        // 如果不需要请求后端就能判定是否登录的结果，就直接判定
        var isLoginWithoutReqRes = self.checkIsLoginWithoutRequest(opt);

        if (isLoginWithoutReqRes !== null) {
          // 能判断结果
          var isLogin = isLoginWithoutReqRes.isLogin;

          if (isLogin) {
            resolve(isLoginWithoutReqRes);
          } else {
            reject(isLoginWithoutReqRes);
          }

          return;
        }

        if (self.requestPool.length) {
          // 已有checkLogin请求发起，尚未未返回结果
          self.requestPool.push({
            resolve: resolve,
            reject: reject
          });
          return;
        }

        self.requestPool.push({
          resolve: resolve,
          reject: reject
        });
        var api = getLoginInterFace({
          type: 'checkLogin'
        });
        var loginReportUrl = location.href;

        if (/\/comm-htdocs\/login\/milosdk/.test(location.href) && miloUrl.request('s_url') && miloUrl.request('s_url').length) {
          try {
            loginReportUrl = decodeURIComponent(miloUrl.request('s_url'));
          } catch (e) {//
          }
        } // 先清除game.qq.com的cookie，防止cookie混淆


        loginStatus.clearAME(function () {
          var _self$getLoginStatusP = self.getLoginStatusParams(),
              appid = _self$getLoginStatusP.appid,
              access_token = _self$getLoginStatusP.access_token,
              openid = _self$getLoginStatusP.openid,
              refresh_token = _self$getLoginStatusP.refresh_token;

          var _self$getLoginStatusP2 = self.getLoginStatusParams(),
              acctype = _self$getLoginStatusP2.acctype;

          var _self$getLoginStatusP3 = self.getLoginStatusParams(),
              uin = _self$getLoginStatusP3.uin;

          var checkData;

          if (!acctype) {
            acctype = 'pt';
          } // 非pt登录


          if ('pt' !== acctype) {
            checkData = {
              acctype: acctype,
              appid: appid,
              access_token: access_token,
              openid: openid,
              refresh_token: refresh_token
            };
          }

          Request.ajax({
            url: api,
            dataType: 'jsonp',
            data: checkData,
            success: function success(result) {
              if (0 == result.errorCode && result.isLogin) {
                // if (result.loginType == 'pt' && !uin && !skey) {
                //   uin = result.uin || result.p_uin;
                //   skey = result.skey || result.p_skey;
                //   loginCookie.setSession({ uin, skey });
                // }
                // 缓存
                var id = "".concat(acctype, "_").concat('pt' !== acctype ? openid : uin);
                loginSvrCache.set(id, result);
                if (result.isLogin) // 获取用户信息
                  // eslint-disable-next-line nonblock-statement-body-position
                  self.getUserInfo({
                    lang: opt.lang,
                    success: function success(userInfo) {
                      // 设置cookie缓存登录态
                      var IED_LOG_INFO_NEW = {
                        acctype: acctype
                      };

                      if ('pt' === acctype) {
                        IED_LOG_INFO_NEW.uin = userInfo.uin;
                        IED_LOG_INFO_NEW.userUin = userInfo.userUin;
                      } else {
                        IED_LOG_INFO_NEW.openid = userInfo.openid;
                      }

                      IED_LOG_INFO_NEW.nickName = userInfo.nickName;
                      IED_LOG_INFO_NEW.avatarUrl = userInfo.avatarUrl;
                      loginCookie.setSession({
                        IED_LOG_INFO_NEW: miloObject.serialize(IED_LOG_INFO_NEW)
                      });

                      while (self.requestPool.length) {
                        var _self$requestPool$pop = self.requestPool.pop(),
                            _resolve = _self$requestPool$pop.resolve; // 登录成功，获取用户信息成功 result：登录返回   userInfo:用户信息


                        _resolve({
                          isLogin: true,
                          result: result,
                          userInfo: userInfo
                        });
                      }
                    },
                    fail: function fail(errInfo) {
                      // 登录成功，获取用户信息失败,result：登录返回
                      console.log('登录成功，但是获取用户信息失败，错误信息为', errInfo);

                      while (self.requestPool.length) {
                        var _self$requestPool$pop2 = self.requestPool.pop(),
                            _resolve2 = _self$requestPool$pop2.resolve; // 登录成功，获取用户信息成功 result：登录返回   userInfo:用户信息


                        _resolve2({
                          isLogin: true,
                          result: result,
                          userInfo: undefined
                        });
                      }
                    }
                  });
              } else {
                while (self.requestPool.length) {
                  var _self$requestPool$pop3 = self.requestPool.pop(),
                      _reject = _self$requestPool$pop3.reject; // 登录成功，获取用户信息成功 result：登录返回   userInfo:用户信息


                  _reject({
                    isLogin: false,
                    errCode: result.errorCode,
                    errInfo: result
                  });
                }
              } // 登录校验请求成功上报


              ATM.reportATM({
                toappid: 1,
                tomoduletype: 100,
                tointer: 4,
                toreturncode: result.errorCode == 0 ? 0 : 1,
                businesstype: getGameId(),
                result: result.errorCode,
                cgi: loginReportUrl,
                errormsg: result.errorStr
              });
            },
            fail: function fail() {
              while (self.requestPool.length) {
                // 网络超时上报
                ATM.reportATM({
                  toappid: 1,
                  tomoduletype: 100,
                  tointer: 4,
                  toreturncode: -999,
                  businesstype: getGameId(),
                  result: -999,
                  cgi: loginReportUrl,
                  errormsg: '网络超时'
                });

                var _self$requestPool$pop4 = self.requestPool.pop(),
                    _reject2 = _self$requestPool$pop4.reject; // 登录成功，获取用户信息成功 result：登录返回   userInfo:用户信息


                _reject2({
                  isLogin: false,
                  errCode: -999,
                  errMsg: '网络请求失败,请稍后重试',
                  errInfo: {
                    errMsg: '网络请求失败,请稍后重试'
                  }
                });
              }
            }
          });
        });
      });
    }
  }, {
    key: "isJsBridgeEffect",
    value: function isJsBridgeEffect() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // add by weiztang 多渠道相关逻辑调整
      var _ref3 = option || {},
          useAppLogin = _ref3.useAppLogin,
          JsBridgeEffectType = _ref3.JsBridgeEffectType; // console.log('====JsBridge开启检测Start，发布版本时记得注释或移除====')
      // console.log('useAppLogin',useAppLogin);
      // console.log('appJsBridge.miloSelfConfig.appName',appJsBridge?appJsBridge.miloSelfConfig.appName:'null');
      // console.log('JsBridgeEffectType',JsBridgeEffectType);
      // console.log('zm effect',JsBridgeEffectType && JsBridgeEffectType === 'logout' && platform.isLoLApp());
      // // console.log('useAppLogin.indexOf(appJsBridge.miloSelfConfig.appName)',appJsBridge?useAppLogin.indexOf(appJsBridge.miloSelfConfig.appName):'null');
      // // console.log('platform.isWxApp()',platform.isWxApp());
      // // console.log('platform.isQQApp()',platform.isQQApp());
      // console.log('====JsBridge开启检测日志End====')
      // 掌盟环境 且 是注销 默认开启jsBridge


      if (JsBridgeEffectType && JsBridgeEffectType === 'logout' && platform.isLoLApp()) {
        return true;
      } // 道聚城环境下全部拦截走道聚城自身逻辑 add by weiztang20221025


      if (platform.isDJC()) {
        return true;
      } // 如果用户传入配置项useAppLogin，且是数组，且当前jsBridge检测到到app类型在配置项存在,且不是微信/QQ环境


      if (!platform.isWxApp() && !platform.isQQApp() && useAppLogin && isArray(useAppLogin) && appJsBridge && appJsBridge.miloSelfConfig && appJsBridge.miloSelfConfig.appName && useAppLogin.indexOf(appJsBridge.miloSelfConfig.appName) !== -1) {
        return true;
      }

      return false;
    }
  }, {
    key: "checkLogin",
    value: function () {
      var _checkLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opt) {
        var self, option, _ref4, isPrivateLogin, loginMethods, _ref5, iUseQQConnect, setAppCookieStatus, JsbridgeLoginType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                option = _objectSpread(_objectSpread({}, this.option.commonParams), opt);
                _ref4 = option || {}, isPrivateLogin = _ref4.isPrivateLogin, loginMethods = _ref4.loginMethods;
                _ref5 = option || {}, iUseQQConnect = _ref5.iUseQQConnect;
                setAppCookieStatus = null;

                if (!this.isJsBridgeEffect(option)) {
                  _context.next = 34;
                  break;
                }

                // 有APP登录态
                JsbridgeLoginType = null;
                _context.prev = 7;

                if (appJsBridge.miloSelfConfig.isMiloWayCookies) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return self.logout({
                  freshWin: false,
                  onlyWebview: true // 只清空webview中milo登录态，不调用app JsBridge登出app

                });

              case 11:
                _context.next = 13;
                return appJsBridge.getLoginType();

              case 13:
                JsbridgeLoginType = _context.sent;
                console.log('JsbridgeLoginType', JsbridgeLoginType);
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);
                console.log(_context.t0);

              case 20:
                if (!JsbridgeLoginType) {
                  _context.next = 34;
                  break;
                }

                _context.prev = 21;
                console.log('before set cookie', document.cookie);
                _context.next = 25;
                return appJsBridge.setAppCookie();

              case 25:
                setAppCookieStatus = _context.sent;
                console.log('after set cookie', document.cookie);

                if (JsbridgeLoginType === 'qc') {
                  iUseQQConnect = 1;
                }

                if (setAppCookieStatus && setAppCookieStatus.miloCode) {
                  // 自定义resolve时候的返回的错误
                  console.log('APP内jsBridge设置cookie失败，可能造成登录态校验失败', setAppCookieStatus);
                }

                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](21);
                // 异常捕捉的提示
                console.log('APP内jsBridge设置cookie失败，可能造成登录态校验失败', _context.t1);

              case 34:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  // 先读url参数种缓存 weiztang 20221226
                  var oCookie = self.getLoginStatusParams(); // 如果不需要请求后端就能判定是否登录的结果，就直接判定

                  var isLoginWithoutReqRes = self.checkIsLoginWithoutRequest(opt); // 多渠道如果遇到中断流程，增加错误码返回

                  if (setAppCookieStatus && setAppCookieStatus.miloCode) {
                    reject({
                      errCode: setAppCookieStatus.miloCode,
                      isLogin: false,
                      errInfo: setAppCookieStatus.errInfo
                    });
                  }

                  if (isLoginWithoutReqRes !== null) {
                    // 能判断结果
                    var _isLogin = isLoginWithoutReqRes.isLogin;

                    if (_isLogin) {
                      resolve(isLoginWithoutReqRes);
                    } else {
                      reject(isLoginWithoutReqRes);
                    }

                    return;
                  }

                  var sCacheCookie = miloCookie.get('IED_LOG_INFO_NEW');
                  var oCache = {};
                  var isLogin = false;
                  var userInfo = {};

                  if (sCacheCookie) {
                    oCache = miloObject.unSerialize(sCacheCookie);
                  }

                  var _oCache = oCache,
                      acctype = _oCache.acctype;

                  if (acctype) {
                    switch (acctype) {
                      case 'pt':
                        {
                          if (oCookie.skey && oCookie.uin && oCookie.uin == oCache.uin) {
                            isLogin = true;
                            userInfo = oCache;
                          }

                          break;
                        }

                      default:
                        if (isLegalAcctype(oCookie.acctype)) {
                          if (oCookie.acctype == oCache.acctype && oCookie.openid == oCache.openid) {
                            isLogin = true;
                            userInfo = oCache;
                          }
                        }

                        break;
                    }
                  }

                  if (isLogin) {
                    resolve({
                      isLogin: true,
                      userInfo: userInfo
                    });
                  } else {
                    self.checkRealLogin().then(function (res) {
                      resolve(res);
                    })["catch"](function (err) {
                      // 如果非私有登录态，则从game.qq.com域名下同步登录态
                      proxyManager.get(isPrivateLogin).then(function (_ref6) {
                        var data = _ref6.data;

                        // 同步wegame登录态，若有，重试checkeRealLogin, 若无执行失败回调
                        if (!data) {
                          reject(err);
                        }

                        var setProxyLoginStatus = false;

                        if (loginMethods && loginMethods.length && !isPrivateLogin) {
                          // 根据loginMethods从左到右的顺序读取proxy的登录态
                          loginMethods.some(function (item) {
                            if ((item === 'wx' || item === 'wxMobile') && data.wx) {
                              var _data$wx = data.wx,
                                  appid = _data$wx.appid,
                                  openid = _data$wx.openid,
                                  access_token = _data$wx.access_token;
                              var currentAppId = item === 'wx' ? self.pcParams.oWXParams.appId : self.mobileParams.oWXParams.appId;

                              if (currentAppId === appid) {
                                var _acctype = 'wx';
                                loginCookie.setLocal({
                                  acctype: _acctype,
                                  appid: appid,
                                  openid: openid,
                                  access_token: access_token
                                }, 7200);
                                setProxyLoginStatus = true;
                                return true;
                              }
                            } else if ((item === 'qc' || item === 'qcMobile') && data.qc && 1 == iUseQQConnect) {
                              var _data$qc = data.qc,
                                  _appid = _data$qc.appid,
                                  _openid = _data$qc.openid,
                                  _access_token = _data$qc.access_token;

                              var _currentAppId = item === 'qc' ? self.pcParams.oQQConnectParams.appId : self.mobileParams.oQQConnectParams.appId;

                              if (_currentAppId === _appid) {
                                var _acctype2 = 'qc';
                                loginCookie.setLocal({
                                  acctype: _acctype2,
                                  appid: _appid,
                                  openid: _openid,
                                  access_token: _access_token
                                }, 7200);
                                setProxyLoginStatus = true;
                                return true;
                              }
                            } else if ((item === 'wg' || item === 'wgMobile') && data.wg) {
                              var _data$wg = data.wg,
                                  _appid2 = _data$wg.appid,
                                  _openid2 = _data$wg.openid,
                                  _access_token2 = _data$wg.access_token;

                              var _currentAppId2 = item === 'wg' ? self.pcParams.oWegameParams.appId : self.mobileParams.oWegameParams.appId;

                              if (_currentAppId2 === _appid2) {
                                var _acctype3 = 'wg';
                                loginCookie.setLocal({
                                  acctype: _acctype3,
                                  appid: _appid2,
                                  openid: _openid2,
                                  access_token: _access_token2
                                }, 7200);
                                setProxyLoginStatus = true;
                                return true;
                              }
                            }
                          });
                        }

                        if (setProxyLoginStatus) {
                          self.checkRealLogin().then(function (res) {
                            resolve(res);
                          })["catch"](function (err) {
                            reject(err);
                          });
                        } else {
                          reject(err);
                        }
                      })["catch"](function (err) {
                        reject(err);
                      });
                    });
                  }
                }));

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 17], [21, 31]]);
      }));

      function checkLogin(_x) {
        return _checkLogin.apply(this, arguments);
      }

      return checkLogin;
    }() // 获取用户登录信息(头像、昵称、性别、国家、省市等)

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this; // eslint-disable-next-line prefer-const

      var _success = opt.success,
          _fail = opt.fail,
          lang = opt.lang;

      var _self$getLoginStatusP4 = self.getLoginStatusParams(),
          acctype = _self$getLoginStatusP4.acctype,
          appid = _self$getLoginStatusP4.appid,
          access_token = _self$getLoginStatusP4.access_token,
          openid = _self$getLoginStatusP4.openid,
          refresh_token = _self$getLoginStatusP4.refresh_token,
          uin = _self$getLoginStatusP4.uin,
          skey = _self$getLoginStatusP4.skey;

      if (!lang) {
        lang = 'zh_CN';
      }

      if (isLegalAcctype(acctype)) {
        if (acctype === 'wx') {
          userInfoManager.getWXUserInfo({
            openid: openid,
            access_token: access_token,
            lang: lang,
            success: function success(userInfo) {
              var info = {
                formatUserInfo: userInfo.formatUserInfo,
                originUserInfo: userInfo.userInfo
              };
              extend(info, info.formatUserInfo);
              info.acctype = 'wx';
              info.openid = openid;
              isFunction(_success) && _success(info);
            },
            fail: function fail(errInfo) {
              isFunction(_fail) && _fail(errInfo);
            }
          });
        } else {
          userInfoManager.getUserInfoByOpenid({
            acctype: acctype,
            openid: openid,
            access_token: access_token,
            refresh_token: refresh_token,
            appid: appid,
            lang: lang,
            success: function success(userInfo) {
              var info = {
                formatUserInfo: userInfo.formatUserInfo,
                originUserInfo: userInfo.userInfo
              };
              extend(info, info.formatUserInfo);
              info.acctype = acctype;
              info.openid = openid;
              isFunction(_success) && _success(info);
            },
            fail: function fail(errInfo) {
              isFunction(_fail) && _fail(errInfo);
            }
          });
        }
      } else if (uin && skey) {
        // pt
        userInfoManager.getPtUserInfo(uin, function (userInfo) {
          var info = {
            formatUserInfo: userInfo && userInfo.formatUserInfo,
            originUserInfo: userInfo && userInfo.userInfo
          };
          extend(info, info.formatUserInfo);
          info.acctype = 'pt';
          isFunction(_success) && _success(info);
        }, function (errInfo) {
          isFunction(_fail) && _fail(errInfo);
        });
      } else {
        var errInfo = {
          formatUserInfo: null,
          originUserInfo: {
            nickName: ''
          },
          acctype: ''
        };
        isFunction(_fail) && _fail(errInfo);
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this = this;

      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread({}, this.option.commonParams), opt);

      return new Promise(function (resolve) {
        // 对掌盟内相关逻辑增加判断
        option.JsBridgeEffectType = 'logout';

        if (_this.isJsBridgeEffect(option) && !option.onlyWebview) {
          appJsBridge.logout();
        }

        var _ref7 = option || {},
            freshWin = _ref7.freshWin,
            jumpUrl = _ref7.jumpUrl,
            callback = _ref7.callback,
            isPrivateLogin = _ref7.isPrivateLogin; // 先清除qq.com下cookie


        loginCookie.clearQQ(); // 再清除本域名cookie

        loginCookie.clearLocal(); // 保证注销回调只执行一次

        var logoutCallbackLock = 2; // eslint-disable-next-line no-multi-assign

        window.logoutPtCallback = window.logoutAppsCallback = function () {
          logoutCallbackLock = logoutCallbackLock - 1; // 减少一次，说明有一个域名下已经注销
          // 保证注销回调只执行最后一次

          if (0 == logoutCallbackLock) {
            if (isFunction(callback)) {
              callback({
                isLogin: false
              });
            }

            resolve({
              isLogin: false
            }); // 判断是否刷新，根据jumpUrl参数执行跳转操作

            if (freshWin) {
              if (jumpUrl) {
                location.href = jumpUrl;
              } else {
                location.reload();
              }
            }
          }
        }; // 先清代理


        proxyManager.clear(isPrivateLogin, function () {
          if (pageSupportDomain) {
            // iframe加载注销bridge页面
            frameManager.open('logoutPt', "".concat(location.protocol, "//game.qq.com/comm-htdocs/login/logout_bridge.html"), function (win) {
              win.logoutPt && win.logoutPt();
            });
            frameManager.open('logoutApps', "".concat(location.protocol, "//apps.game.qq.com/ams/logout_bridge.html"), function (win) {
              win.logoutApps && win.logoutApps();
            });
          } else {
            frameManager.postFrame('logoutPt', "".concat(location.protocol, "//game.qq.com/comm-htdocs/login/logout_bridge.html"), function () {
              postMessageProxy.postMessage('loginmanager_logoutPt', 'logoutPt', 'logoutAppsCallback');
            }, 'loginmanager_logoutPt');
            frameManager.postFrame('logoutApps', "".concat(location.protocol, "//apps.game.qq.com/ams/logout_bridge.html"), function () {
              postMessageProxy.postMessage('loginmanager_logoutApps', 'logoutApps', 'logoutAppsCallback');
            }, 'loginmanager_logoutApps');
          }
        });
      });
    }
    /** **************** PC登录方法*************/

  }, {
    key: "loginByQQ",
    value: function loginByQQ() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var iUseQQConnect = typeof opt.iUseQQConnect !== 'undefined' ? opt.iUseQQConnect : this.option.commonParams.iUseQQConnect;
      var qqParams = iUseQQConnect == 1 ? this.option.pcParams.oQQConnectParams : this.option.pcParams.oQQParams;

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), qqParams), {}, {
        showParams: _objectSpread(_objectSpread({}, this.option.pcParams.showParams), qqParams.showParams)
      }, opt);

      return loginByQQ_PC.call(this, option);
    }
  }, {
    key: "loginByWX",
    value: function loginByWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oWXParams), {}, {
        showParams: _objectSpread(_objectSpread({}, this.option.pcParams.showParams), this.option.pcParams.oWXParams.showParams)
      }, opt);

      return loginByWX_PC.call(this, option);
    } // wegame登录

  }, {
    key: "loginByWegame",
    value: function loginByWegame() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oWegameParams), {}, {
        showParams: _objectSpread(_objectSpread({}, this.option.pcParams.showParams), this.option.pcParams.oWegameParams.showParams)
      }, opt);

      return loginByWegame_PC.call(this, option);
    } // QQ互联登录

  }, {
    key: "loginByQQConnect",
    value: function loginByQQConnect() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oQQConnectParams), {}, {
        showParams: _objectSpread(_objectSpread({}, this.option.pcParams.showParams), this.option.pcParams.oQQConnectParams.showParams)
      }, opt);

      return loginByQQConnect_PC.call(this, option);
    } // QQ微信联合登录

  }, {
    key: "loginByQQAndWX",
    value: function loginByQQAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var iUseQQConnect = typeof opt.iUseQQConnect !== 'undefined' ? opt.iUseQQConnect : this.option.commonParams.iUseQQConnect;
      var qqParams = iUseQQConnect == 1 ? this.option.pcParams.oQQConnectParams : this.option.pcParams.oQQParams;

      var option = _objectSpread({
        oQQParams: _objectSpread(_objectSpread({}, this.option.commonParams), qqParams),
        oWXParams: _objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oWXParams),
        showParams: _objectSpread({}, this.option.pcParams.showParams)
      }, opt);

      return loginByQQAndWX_PC.call(this, option);
    } // QC微信联合登录

  }, {
    key: "loginByQQConnectAndWX",
    value: function loginByQQConnectAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread({
        oQQConnectParams: _objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oQQConnectParams),
        oWXParams: _objectSpread(_objectSpread({}, this.option.commonParams), this.option.pcParams.oWXParams),
        showParams: _objectSpread({}, this.option.pcParams.showParams)
      }, opt);

      return loginByQQConnectAndWX_PC.call(this, option);
    }
  }, {
    key: "loginByWxDelegate",
    value: function loginByWxDelegate() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _loginByWxDelegate.call(this, opt);
    }
    /** --------------------------移动端登录----------------------- */

  }, {
    key: "mobileLoginByQQ",
    value: function mobileLoginByQQ() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var iUseQQConnect = typeof opt.iUseQQConnect !== 'undefined' ? opt.iUseQQConnect : this.option.commonParams.iUseQQConnect;
      var qqParams = iUseQQConnect == 1 ? this.option.mobileParams.oQQConnectParams : this.option.mobileParams.oQQParams;

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), qqParams), opt);

      if (this.isJsBridgeEffect(option)) {
        appJsBridge.loginByQQ();
        return;
      }

      return loginByQQ_Mobile.call(this, option);
    }
  }, {
    key: "mobileLoginByQQConnect",
    value: function mobileLoginByQQConnect() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oQQConnectParams), opt);

      if (this.isJsBridgeEffect(option)) {
        appJsBridge.loginByQQ();
        return;
      }

      return loginByQQConnect_Mobile.call(this, option);
    }
  }, {
    key: "mobileLoginByWX",
    value: function mobileLoginByWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oWXParams), opt);

      if (this.isJsBridgeEffect(option)) {
        appJsBridge.loginByWX();
        return;
      }

      return loginByWX_Mobile.call(this, option);
    } // QQ微信联合登录

  }, {
    key: "mobileLoginByQQAndWX",
    value: function mobileLoginByQQAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var iUseQQConnect = typeof opt.iUseQQConnect !== 'undefined' ? opt.iUseQQConnect : this.option.commonParams.iUseQQConnect;
      var qqParams = iUseQQConnect == 1 ? this.option.mobileParams.oQQConnectParams : this.option.mobileParams.oQQParams;

      var option = _objectSpread({
        oQQParams: _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), qqParams), {}, {
          iUseQQConnect: iUseQQConnect
        }),
        oWXParams: _objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oWXParams),
        showParams: _objectSpread({}, this.option.mobileParams.showParams)
      }, opt);

      if (this.isJsBridgeEffect(option)) {
        appJsBridge.loginByQQAndWX();
        return;
      }

      return loginByQQAndWX_Mobile.call(this, option);
    } // QC微信联合登录

  }, {
    key: "mobileLoginByQQConnectAndWX",
    value: function mobileLoginByQQConnectAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var iUseQQConnect = typeof opt.iUseQQConnect !== 'undefined' ? opt.iUseQQConnect : this.option.commonParams.iUseQQConnect;
      var qqParams = iUseQQConnect == 1 ? this.option.mobileParams.oQQConnectParams : this.option.mobileParams.oQQParams;

      var option = _objectSpread({
        oQConnectParams: _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), qqParams), {}, {
          iUseQQConnect: iUseQQConnect
        }),
        oWXParams: _objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oWXParams),
        showParams: _objectSpread({}, this.option.mobileParams.showParams)
      }, opt);

      if (this.isJsBridgeEffect(option)) {
        appJsBridge.loginByQQAndWX();
        return;
      }

      return loginByQCAndWX_Mobile.call(this, option);
    }
  }, {
    key: "mobileLoginByWegame",
    value: function mobileLoginByWegame() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oWegameParams), opt);

      return loginByWegame_Mobile.call(this, option);
    }
  }, {
    key: "mobileLoginByKs",
    value: function mobileLoginByKs() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var option = _objectSpread(_objectSpread(_objectSpread({}, this.option.commonParams), this.option.mobileParams.oKsParams), opt);

      return loginByKs_Mobile.call(this, option);
    }
    /** ***** 登录中转页所需函数 ****************************************/
    // 刷新wegame登录态

  }, {
    key: "refreshWegame",
    value: function refreshWegame(success, fail) {
      if (platform.isMobile()) {
        return refreshWegame_Mobile.call(this, success, fail);
      }

      return refreshWegame_PC.call(this, success, fail);
    } // wx codeToOpenid调用

  }, {
    key: "wxCodeToOpenid",
    value: function wxCodeToOpenid() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _callback = arguments.length > 1 ? arguments[1] : undefined;

      var self = this;
      var appid = opt.appid,
          code = opt.code;
      var wxcodedomain = location.host;
      var codeToOpenIdUrl = getLoginInterFace({
        acctype: 'wx',
        type: 'codetoopenid'
      }); // 执行codeToOpenId

      loginStatus.clearAME(function () {
        Request.ajax({
          url: codeToOpenIdUrl,
          type: 'GET',
          dataType: 'jsonp',
          data: {
            appid: appid,
            wxcode: code,
            wxcodedomain: wxcodedomain,
            acctype: 'wx',
            sServiceType: 'undefined'
          },
          success: function success(retObj) {
            var iRet = retObj.iRet,
                sMsg = retObj.sMsg,
                errcode = retObj.errcode,
                sLogSerialNum = retObj.sLogSerialNum,
                errmsg = retObj.errmsg;

            if (0 == iRet) {
              var objData = JSON.parse(sMsg); // 设置cookie

              var access_token = objData.access_token,
                  expires_in = objData.expires_in,
                  openid = objData.openid,
                  refresh_token = objData.refresh_token;
              loginCookie.setLocal({
                acctype: 'wx',
                openid: openid,
                appid: appid,
                access_token: access_token,
                refresh_token: refresh_token
              }, expires_in); // 设置登录态同步到game.qq.com

              proxyManager.set('wx', {
                appid: appid,
                openid: openid,
                access_token: access_token,
                refresh_token: refresh_token
              }, function () {}); // 校验登录态

              self.checkRealLogin().then(function (_ref8) {
                var userInfo = _ref8.userInfo;
                isFunction(_callback) && _callback({
                  iRet: 0,
                  sMsg: '登录成功~',
                  userInfo: userInfo
                });
              })["catch"](function (err) {
                isFunction(_callback) && _callback({
                  iRet: 2,
                  sMsg: '鉴权失败，请重试~',
                  errCode: err.errCode
                });
              });
            } else {
              self.logout({
                callback: function callback() {
                  isFunction(_callback) && _callback({
                    iRet: iRet,
                    sMsg: sMsg,
                    errcode: errcode,
                    errmsg: errmsg
                  });
                }
              });
            }

            ATM.reportATM({
              toappid: 1,
              tomoduletype: 32,
              tointer: 2,
              toreturncode: iRet === 0 ? 0 : 1,
              businesstype: getGameId(),
              result: iRet,
              serialnum: sLogSerialNum,
              cgi: location.href,
              errormsg: sMsg
            });
          },
          fail: function fail() {
            ATM.reportATM({
              toappid: 1,
              tomoduletype: 32,
              tointer: 2,
              toreturncode: 1,
              // 失败
              businesstype: getGameId(),
              result: -999,
              serialnum: '',
              cgi: location.href,
              errormsg: '网络超时'
            });
            isFunction(_callback) && _callback({
              iRet: 1,
              sMsg: '网络繁忙，请重试'
            });
          }
        });
      });
    } // TODO: ATM上报

  }, {
    key: "qcCodeToSession",
    value: function qcCodeToSession() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _callback2 = arguments.length > 1 ? arguments[1] : undefined;

      var self = this;
      var code = opt.code,
          appid = opt.appid,
          redirectUri = opt.redirectUri;

      if (!code) {
        isFunction(_callback2) && _callback2({
          iRet: 1,
          // iRet: 1 code缺失   2：codeToAccessToken失效   3:获取用户信息失效
          sMsg: '参数code缺失'
        });
        return;
      }

      var requestData = {
        a: 'qcCodeToOpenId',
        qc_code: code,
        appid: appid,
        redirect_uri: encodeURIComponent(redirectUri || 'https://milo.qq.com/comm-htdocs/login/qc_redirect.html')
      };
      var api = getLoginInterFace({
        type: 'codetoopenid',
        acctype: 'qc'
      });
      Request.ajax({
        url: api,
        dataType: 'jsonp',
        data: requestData,
        success: function success(retObj) {
          loginCookie.setSession({
            qclogin_code: code
          });

          if (0 == retObj.iRet) {
            var openid = retObj.openid,
                access_token = retObj.access_token;
            var acctype = 'qc';
            loginCookie.setLocal({
              appid: appid,
              openid: openid,
              access_token: access_token,
              acctype: acctype
            }); // 设置登录态同步到game.qq.com

            proxyManager.set('qc', {
              appid: appid,
              openid: openid,
              access_token: access_token
            }, function () {});
            isFunction(_callback2) && _callback2({
              iRet: 0,
              sMsg: '登录成功'
            });
          } else {
            self.logout({
              callback: function callback() {
                isFunction(_callback2) && _callback2({
                  iRet: 2,
                  oriRet: retObj.iRet,
                  sMsg: retObj.sMsg
                });
              }
            });
          }
        },
        fail: function fail() {
          isFunction(_callback2) && _callback2({
            iRet: 2,
            sMsg: '授权失败，请重试'
          });
        }
      });
    } // TODO: ATM上报

  }, {
    key: "wegameCodeToSession",
    value: function wegameCodeToSession(codeOption, _callback3) {
      var self = this; // code换取access_token和openid等

      var params = {
        a: 'wgCodeToRailId',
        wg_code: codeOption.code,
        appid: codeOption.appid,
        redirect_uri: codeOption.redirectUri
      };
      Request.ajax({
        url: "".concat(location.protocol, "//ams.game.qq.com/ams/userLoginSvr?").concat(miloObject.serialize(params)),
        type: 'GET',
        dataType: 'jsonp',
        success: function success(retObj) {
          var iRet = retObj.iRet,
              sMsg = retObj.sMsg,
              errcode = retObj.errcode,
              errormsg = retObj.errormsg;

          if (0 == retObj.iRet) {
            var data = retObj;
            var expires_in = data.expires_in || 3600;
            var openid = data.openid,
                access_token = data.access_token,
                refresh_token = data.refresh_token;
            var appid = codeOption.appid;
            loginCookie.setLocal({
              acctype: 'wg',
              openid: openid,
              appid: appid,
              access_token: access_token,
              refresh_token: refresh_token
            }, expires_in); // 鉴权API

            proxyManager.set('wg', {
              appid: appid,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token
            }, function () {}); // 校验登录态

            self.checkRealLogin(function (_ref9) {
              var userInfo = _ref9.userInfo;
              isFunction(_callback3) && _callback3({
                iRet: 0,
                sMsg: '登录成功~',
                userInfo: userInfo
              });
            })["catch"](function () {
              isFunction(_callback3) && _callback3({
                iRet: 2,
                sMsg: '鉴权失败，请重试~'
              });
            });
          } else {
            self.logout({
              callback: function callback() {
                isFunction(_callback3) && _callback3({
                  iRet: iRet,
                  sMsg: sMsg,
                  errcode: errcode,
                  errormsg: errormsg
                });
              }
            });
          }
        },
        error: function error() {}
      }); // })
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      return LoginManager.instance;
    }
  }]);

  return LoginManager;
}();

export default LoginManager;